<template>
    <div>
        <FullPageLoader :isLoading="searching"/>

        <CustomerMail
            v-if="customer"
            type="hidden-button"
            ref="customerMail"
            :customer="customer"
        />

        <div v-if="customer && typeof(customer) == 'object'">
            <slide-up-down :active="mode == 'edit' && showAlert" :duration="200" class="row">
                <div class="column">
                    <b-notification type="is-warning" aria-close-label="Close notification" role="alert">
                        Hier alleen de informatie van de gebruiker aanpassen, deze functie is niet bedoeld om een nieuwe gebruiker aan te maken.
                    </b-notification>
                </div>
            </slide-up-down>

            <div class="row" v-if="user && user.role == 'pit' && $store.state.env === 'local'">
                <div class="column">
                    <b-field label="Organisatie (PIT admin) - Local only"
                        :message="getError(errors, 'organisation')"
                        :type="getType(errors, 'organisation', '')"
                    >
                        <span v-if="mode == 'edit'">
                            <b-select placeholder="Selecteer een organisatie" v-model="customer.organisation" expanded>
                                <option
                                    v-for="organisation in organisations"
                                    :value="organisation.id"
                                    :key="'organisatie_'+organisation.id"
                                >(ID: {{ organisation.id }}) {{ organisation.name }}</option>
                            </b-select>
                        </span>
                        <span v-else-if="mode == 'view' && organisations[customer.organisation]" class="underlined">ID: {{ customer.organisation }} - {{ _.has(organisations, customer.organisation) ? organisations[customer.organisation].name : '-' }}</span>
                        <span v-else>Onbekend</span>
                    </b-field>
                </div>
            </div>

            <div class="row" v-if="mode == 'view' && (embedded_from != 'ContractsRecord' && embedded_from != 'CreateInvoiceRecord')">
                <div class="column text-right">
                    <b-button type="is-info" tag="router-link" :to="`/panel/klanten/${customer.id}`">
                        Klant bekijken
                    </b-button>

                    <b-tooltip label="Klant mailen">
                        <b-button type="is-info" outlined @click="$refs.customerMail.openModal()" icon-right="paper-plane" />
                    </b-tooltip>
                </div>
            </div>

            <div class="row">
                <div class="column medium-6">
                    <b-field label="Voornaam *"
                        :message="getError(errors, 'firstname')"
                        :type="getType(errors, 'firstname', '')"
                    >
                        <span v-if="mode == 'edit'">
                            <b-input placeholder="Voornaam" v-model="customer.firstname" @keyup.native="$emit('passName', customer.firstname+' '+customer.lastname)" :disabled="saving"></b-input>
                        </span>
                        <span v-else-if="mode == 'view'" class="underlined">{{ customer.firstname }}</span>
                    </b-field>
                </div>
                <div class="column medium-6">
                    <b-field label="Achternaam *"
                        :message="getError(errors, 'lastname')"
                        :type="getType(errors, 'lastname', '')"
                    >
                        <span v-if="mode == 'edit'">
                            <b-input placeholder="Achternaam" v-model="customer.lastname" :disabled="saving" @keyup.native="$emit('passName', customer.firstname+' '+customer.lastname)"></b-input>
                        </span>
                        <span v-else-if="mode == 'view'" class="underlined">{{ customer.lastname }}</span>
                    </b-field>
                </div>
            </div>

            <div class="row">
                <div class="column medium-6">
                    <b-field label="E-mailadres *"
                        :message="getError(errors, 'email')"
                        :type="getType(errors, 'email', '')"
                    >
                        <span v-if="mode == 'edit'">
                            <b-input placeholder="email@adres.nl" type="email" v-model="customer.email" :disabled="saving"></b-input>
                        </span>
                        <span v-else-if="mode == 'view'" class="underlined">{{ customer.email }}</span>
                    </b-field>
                </div>
                <div class="column medium-3">
                    <b-field label="Soort klant *"
                        :message="getError(errors, 'type')"
                        :type="getType(errors, 'type', '')"
                    >
                        <span v-if="mode == 'edit'">
                            <b-select placeholder="Soort" expanded v-model="customer.type" :disabled="saving">
                                <option value="normal">Particulier</option>
                                <option value="business">Zakelijk</option>
                                <option value="foundation">Stichting</option>
                            </b-select>
                        </span>
                        <span v-else-if="mode == 'view'" class="underlined">{{ customer.type == 'normal' ? 'Particulier' : customer.type == 'business' ? 'Zakelijk' : customer.type == 'foundation' ? 'Stichting' : customer.type }}</span>
                    </b-field>
                </div>
                <div class="column medium-3">
                    <b-field label="Geslacht *"
                        :message="getError(errors, 'sex')"
                        :type="getType(errors, 'sex', '')"
                    >
                        <span v-if="mode == 'edit'">
                            <b-select placeholder="Geslacht" expanded v-model="customer.sex" :disabled="saving">
                                <option value="male">Man</option>
                                <option value="female">Vrouw</option>
                                <option value="other">Anders</option>
                            </b-select>
                        </span>
                        <span v-else-if="mode == 'view'" class="underlined">{{ customer.sex == 'male' ? 'Man' : customer.sex == 'female' ? 'Vrouw' : customer.sex == 'other' ? 'Anders' : customer.sex }}</span>
                    </b-field>
                </div>
            </div>

            <div class="row">
                <div class="column medium-6">
                    <b-field label="Telefoonnummer"
                        :message="getError(errors, 'telephone')"
                        :type="getType(errors, 'telephone', '')"
                    >
                        <span v-if="mode == 'edit'">
                            <b-input placeholder="023-4567890" v-model="customer.telephone" :disabled="saving"></b-input>
                        </span>
                        <span v-else-if="mode == 'view'" class="underlined">{{ customer.telephone }}</span>
                    </b-field>
                </div>
                <div class="column medium-6">
                    <b-field label="Mobiel"
                        :message="getError(errors, 'mobile')"
                        :type="getType(errors, 'mobile', '')"
                    >
                        <span v-if="mode == 'edit'">
                            <b-input placeholder="06-23456789" v-model="customer.mobile" :disabled="saving"></b-input>
                        </span>
                        <span v-else-if="mode == 'view'" class="underlined">{{ customer.mobile }}</span>
                    </b-field>
                </div>
            </div>

            <div class="row">
                <div class="column medium-6">
                    <b-field label="ID nummer / paspoortnummer"
                        :message="getError(errors, 'id_number')"
                        :type="getType(errors, 'id_number', '')"
                    >
                        <span v-if="mode == 'edit'">
                            <b-input placeholder="AB123456C" v-model="customer.id_number" :disabled="saving"></b-input>
                        </span>
                        <span v-else-if="mode == 'view'" class="underlined">{{ customer.id_number }}</span>
                    </b-field>
                </div>
            </div>

            <slide-up-down :active="customer.type == 'business' || customer.type == 'foundation'" :duration="500">
                <div class="row">
                    <div class="column medium-12">
                        <b-field label="Bedrijfsnaam *"
                            :message="getError(errors, 'companyname')"
                            :type="getType(errors, 'companyname', '')"
                        >
                            <span v-if="mode == 'edit'">
                                <b-input placeholder="Bedrijfsnaam" type="text" v-model="customer.companyname" :disabled="saving"></b-input>
                            </span>
                            <span v-else-if="mode == 'view'" class="underlined">{{ customer.companyname }}</span>
                        </b-field>
                    </div>
                </div>
                <div class="row">
                    <div class="column medium-6">
                        <b-field label="KvK nummer *"
                            :message="getError(errors, 'kvk')"
                            :type="getType(errors, 'kvk', '')"
                        >
                            <span v-if="mode == 'edit'">
                                <b-input placeholder="12345678" type="text" v-model="customer.kvk" :disabled="saving"></b-input>
                            </span>
                            <span v-else-if="mode == 'view'" class="underlined">{{ customer.kvk }}</span>
                        </b-field>
                    </div>
                    <div class="column medium-6">
                        <b-field label="BTW nummer *"
                            :message="getError(errors, 'btw')"
                            :type="getType(errors, 'btw', '')"
                        >
                            <span v-if="mode == 'edit'">
                                <b-input placeholder="NL001234567B01" type="text" v-model="customer.btw" :disabled="saving"></b-input>
                            </span>
                            <span v-else-if="mode == 'view'" class="underlined">{{ customer.btw }}</span>
                        </b-field>
                    </div>
                </div>
            </slide-up-down>

            <div class="row">
                <div class="column">
                    <b-field label="Land *"
                        :message="getError(errors, 'country')"
                        :type="getType(errors, 'country', '')"
                    >
                        <span v-if="mode == 'edit'">
                            <b-select placeholder="Maak een keuze" expanded v-model="customer.country" :disabled="saving">
                                <option value="Nederland">Nederland</option>
                                <option value="Belgie">Belgie</option>
                                <option value="Luxemburg">Luxemburg</option>
                                <option value="Duitsland">Duitsland</option>
                                <option value="Frankrijk">Frankrijk</option>
                                <option value="Polen">Polen</option>
                                <option value="Spanje">Spanje</option>
                                <option value="Portugal">Portugal</option>
                                <option value="Italië">Italië</option>
                            </b-select>
                        </span>
                        <span v-else-if="mode == 'view'" class="underlined">{{ customer.country }}</span>
                    </b-field>
                </div>
            </div>

            <div class="row">
                <div class="column medium-6 large-3">
                    <b-field label="Postcode *"
                        :message="getError(errors, 'zipcode')"
                        :type="getType(errors, 'zipcode', '')"
                    >
                        <span v-if="mode == 'edit'">
                            <b-input v-model="customer.zipcode"
                                placeholder="1234 AA"
                                :disabled="saving"
                                @input="inputsTouched.zipcode = true"></b-input>
                        </span>
                        <span v-else-if="mode == 'view'" class="underlined">{{ customer.zipcode }}</span>
                    </b-field>
                </div>
                <div class="column medium-6 large-3 end">
                    <b-field label="Huisnummer *"
                        :message="getError(errors, 'address2')"
                        :type="getType(errors, 'address2', '')"
                    >
                        <span v-if="mode == 'edit'">
                            <b-input v-model="customer.address2"
                                placeholder="123A"
                                :disabled="saving"
                                @input="inputsTouched.address2 = true"></b-input>
                        </span>
                        <span v-else-if="mode == 'view'" class="underlined">{{ customer.address2 }}</span>
                    </b-field>
                </div>
                <div class="column medium-12 large-6" v-if="mode == 'edit'">
                    <div class="buttons" style="margin-top: 2rem;">
                        <b-button type="is-info"
                            :disabled="!customer.zipcode || !customer.address2 || saving || customer.country !== 'Nederland' ||
                                     (lastSearched.zipcode === customer.zipcode.replace(/\s+/g, '') && lastSearched.address2 === customer.address2)"
                            @click="searchAddress">
                            Zoek adres
                        </b-button>
                        <span style="margin: 0px 0.5rem 0 0; line-height: 24px; vertical-align: middle; height: 30px;">of</span>
                        <b-button type="is-dark"
                            @click="showManualAddress = true">
                            Handmatig invullen
                        </b-button>
                    </div>
                </div>
            </div>

            <slide-up-down :active="(mode == 'edit' || mode == 'view') && ((showManualAddress || customer.address) && customer.country === 'Nederland' || customer.country !== 'Nederland')" :duration="300">
                <div class="address-block" :class="{'is-filled': customer.address}">
                    <div class="row">
                        <div class="column medium-6 large-8 paddingtop0 paddingbottom0">
                            <b-field label="Straat *"
                                :message="getError(errors, 'address')"
                                :type="getType(errors, 'address', '')"
                            >
                                <span v-if="mode == 'edit'">
                                    <b-input v-model="customer.address" placeholder="Voorbeeldstraat" :disabled="saving"></b-input>
                                </span>
                                <span v-else-if="mode == 'view'" class="underlined">{{ customer.address }}</span>
                            </b-field>
                        </div>
                        <div class="column medium-6 large-4 paddingtop0 paddingbottom0">
                            <b-field label="Plaats *"
                                :message="getError(errors, 'city')"
                                :type="getType(errors, 'city', '')"
                            >
                                <span v-if="mode == 'edit'">
                                    <b-input v-model="customer.city" placeholder="Plaatsnaam" :disabled="saving"></b-input>
                                </span>
                                <span v-else-if="mode == 'view'" class="underlined">{{ customer.city }}</span>
                            </b-field>
                        </div>
                    </div>
                </div>
            </slide-up-down>

            <div class="row">
                <div class="column medium-6" :key="'bankname-' + ibanRequired">
                    <b-field :label="bankNameLabel"
                        :message="getError(errors, 'bankname')"
                        :type="getType(errors, 'bankname', '')"
                    >
                        <span v-if="mode == 'edit'">
                            <b-input v-model="customer.bankname" placeholder="Mr. Voornaam Achternaam" :disabled="saving"></b-input>
                        </span>
                        <span v-else-if="mode == 'view'" class="underlined">{{ customer.bankname }}</span>
                    </b-field>
                </div>
                <div class="column medium-6" :key="'banknumber-' + ibanRequired">
                    <IBANInput
                        v-if="customer"
                        :value="customer.banknumber"
                        :mode="mode"
                        :disabled="saving"
                        label="Bankrekeningnummer (IBAN)"
                        :error-message="getError(errors, 'banknumber')"
                        :error-type="getType(errors, 'banknumber', '')"
                        @update="customer.banknumber = $event"
                    />
                </div>
            </div>

            <div class="row" v-if="mode == 'edit'">
                <div class="column small-3">
                    <p><small>* Verplichte velden</small></p>
                </div>

                <div class="column small-9 text-right">
                    <span v-if="embedded_from && (embedded_from == 'CustomerRecord' || embedded_from == 'ContractRecord')">
                        <!-- <b-button type="is-light" :loading="saving" @click="$emit('closeModal')" v-if="embedded_from && embedded_from == 'ContractRecord'">Annuleren</b-button> -->
                        <b-button type="is-success" v-if="!user.deurwaarder" :loading="saving" @click="saveAndQuit">{{ customer.draft ? 'Nieuwe klant opslaan' : 'Opslaan' }}</b-button>
                    </span>
                    <span v-else>
                        <b-button type="is-light" :disabled="saving" @click="cancelEdit">Annuleren</b-button>
                        <b-button type="is-success" v-if="!user.deurwaarder" :loading="saving" @click="saveCustomer">Gegevens opslaan</b-button>
                    </span>
                </div>
            </div>
        </div>

        <div v-if="mode == 'view'">
            <div class="row">
                <div class="column small-3">
                    <p><small>* Verplichte velden</small></p>
                </div>
                <div class="column text-right paddingbottom0">
                    <b-button type="is-danger" :loading="customer == null" @click="deleteCustomer" v-if="canDeleteCustomer">Gebruiker verwijderen</b-button>
                    <b-button type="is-danger" :loading="customer == null" @click="removeCustomer" v-if="canRemoveCustomer">Klant ontkoppelen</b-button>
                    <b-button type="is-dark" outlined :loading="customer == null" @click="editCustomer" v-if="!hideEditButton && !user.deurwaarder">Gegevens aanpassen</b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import formvalidationMixin from '@/mixins/formvalidationMixin.js'
import addressMixin from '@/mixins/addressMixin.js'
import CustomerMail from '@/vue/customers/components/CustomerMail.vue'
import IBANInput from '@/vue/components/IBANinput.vue'

export default {
    name: 'CRUDCustomer',

    props: {
        type: {
            type: String,
            default: 'view',
            required: false
        },
        id: {
            type: Number|String,
            required: false
        },
        getCustomer: {
            type: Object,
            required: false
        },
        canRemoveCustomer: {
            type: Boolean,
            default: false,
            required: false
        },
        canDeleteCustomer: {
            type: Boolean,
            default: false,
            required: false
        },
        showAlert: {
            type: Boolean,
            required: false,
            default: false
        },
        embedded_from: {
            type: String,
            required: false
        },
        hideEditButton: {
            type: Boolean,
            required: false,
            default: false
        },
        organisation: {
            type: [Number, String],
            required: false,
            default: null
        },
        ibanRequired: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    components: {
        CustomerMail,
        IBANInput
    },

    mixins: [formvalidationMixin, addressMixin],

    data() {
        return {
            searching: false,
            customer: {},
            mode: 'view', // view/edit
            saving: false,
            backupData: {}, // for cancel
            errors: {},
            showManualAddress: false,
            inputsTouched: {
                zipcode: false,
                address2: false
            },
            lastSearched: {}
        }
    },

    computed: {
        user() {
            return this.$store.state.user
        },

        organisations() {
            return this.$store.state.organisations ? this.$store.state.organisations : null
        },

        bankNameLabel() {
            return `Naam rekeninghouder${this.ibanRequired ? ' *' : ''}`
        },

        bankNumberLabel() {
            return `Bankrekeningnummer (IBAN)${this.ibanRequired ? ' *' : ''}`
        }
    },

    created() {
        // Open in different view/mode (if defined/passed)
        if(this.type) {
            Vue.set(this, 'mode', this.type)
        }

        if(this.id == 'nieuw'){
            this.$set(this.customer, 'type', 'normal')
            this.$set(this.customer, 'country', 'Nederland')
            this.$set(this.customer, 'organisation', this.user.organisation)
        }

        if(this.id && !this.getCustomer){
            if(typeof(this.id) == 'number'){
                this.fetchCustomerWithID(parseInt(this.id))
            } else if(this.id == 'nieuw') {
                this.mode = 'edit'
                this.$emit('fullPageLoader', false)
            }
        }
    },

    methods: {
        fetchCustomerWithID(id){
            console.log('[🔥] Searching for a customer with id: '+id)
            this.searching = true

            axios({
                method: 'get',
                url: '/api/customer/'+id,
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.customer = response.data
                // Reset touched state when loading customer
                this.resetInputTouched()
                this.$emit('passName', response.data.firstname+' '+response.data.lastname)
                this.$emit('linkCustomer', response.data)
                this.$emit('passDraft', !!response.data.draft)
                this.$emit('passCustomer', response.data)
            }).catch((error) => {
                console.error('[❌] Error while fetching customer with ID '+id, error)
            }).then(() => {
                this.searching = false
                this.$emit('fullPageLoader', false)
            })
        },

        editCustomer(){
            this.backupData = {...this.customer}
            this.mode = 'edit'
            // Reset touched state when entering edit mode
            this.resetInputTouched()
            this.$emit('customerModeChanged', 'edit')
        },

        removeCustomer(){
            this.$emit('removeCustomer')
        },

        cancelEdit(){
            this.customer = {...this.backupData}
            this.backupData = {}
            this.errors = {}
            this.mode = 'view'
            this.resetInputTouched()
            this.$emit('customerModeChanged', 'view')
        },

        resetInputTouched() {
            this.inputsTouched.zipcode = false
            this.inputsTouched.address2 = false
        },

        saveAndQuit() {
            this.$emit('fullPageLoader', true)

            this.save().then((response) => {
                // Emit event so parent components can react to customer changes
                this.$emit('customerSaved', response)

                if(this.embedded_from == 'ContractRecord'){
                    this.$emit('linkCustomer', response)
                } else {
                    this.$router.push({name: 'CustomersOverview'})
                }
            }).catch((e) => {
                console.error(e)
            })
        },

        saveCustomer(){
            this.saving = true
            this.errors = {}
            this.$emit('fullPageLoader', 'customer_edit')

            this.save().then((response) => {
                Vue.set(this, 'customer', response)
                this.mode = 'view'
                // Emit event so parent components can react to customer changes
                this.$emit('customerSaved', response)
                this.$emit('customerModeChanged', 'view')
                this.$emit('passName', response.firstname+' '+response.lastname) // for CustomerRecord
                this.$emit('linkCustomer', response)
            })
        },

        save(){
            return new Promise((resolve, reject) => {
                let url = '/api/customer/'+(this.customer.id ? this.customer.id : 'nieuw')+'/save'
                if (this.ibanRequired) {
                    url += '?ibanRequired=true'
                }

                axios.put(url, {...this.customer}, {
                    headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
                }).then((response) => {
                    this.$buefy.toast.open({message: 'Succesvol opgeslagen!', type: 'is-success'})

                    resolve(response.data)
                }).catch((error) => {
                    console.error('[❌] Error while updating customer', error)
                    this.errors = {...error.response.data.errors}
                    this.showManualAddress = true // Show manual address field if error to show errors in hidden fields

                    this.$buefy.toast.open({
                        message: 'Opslaan mislukt - Onvoldoende of onjuiste gegevens.',
                        type: 'is-danger'
                    })

                    reject()
                }).then(() => {
                    this.saving = false
                    this.$emit('fullPageLoader', false)
                })
            })
        },

        deleteCustomer(){
            console.log('TO DO: Delete customer! (deleted_at)?, check of uberhaubt mogelijk.. geen contracten etc op deze customer anders: verwijderen niet mogelijk.')
        },

        cancelEdit(){
            this.customer = {...this.backupData}
            this.backupData = {}
            this.errors = {}
            this.mode = 'view'
            this.resetInputTouched()
            this.$emit('customerModeChanged', 'view')
        },
    },
    watch: {
        getCustomer: {
            handler(newVal) {
                if(newVal && Object.keys(newVal).length){
                    Vue.set(this, 'customer', newVal)
                    this.resetInputTouched()
                }
            },
            immediate: true
        },
        organisation: {
            handler(newVal){
                if(newVal){
                    this.customer.organisation = newVal
                }
            }, immediate: true
        }
    }
}
</script>

<style scoped>
.address-block {
    background-color: #f5f5f5;
    padding: 1rem;
    border-radius: 4px;
    margin: 1rem 0;
    transition: all 0.3s ease;
}

.address-block.is-filled {
    background-color: #f0f7ff;
    border: 1px solid #dbedff;
}
</style>
